// PermissionGuard.jsx
import React from "react";
import PropTypes from "prop-types";
import { FaExclamationTriangle } from "react-icons/fa";
import { useAdminStore } from "../utils/store";

export default function PermissionGuard({ permission, children }) {
  const {
    user: { data },
  } = useAdminStore();

  const permissions = data?.permissions || [];
  const hasAccess = permissions.includes(permission);

  if (!hasAccess) {
    return (
      <div
        className="flex items-center p-4 mb-4 border border-red-300 bg-red-50 text-red-800 rounded-md"
        role="alert"
        aria-live="assertive"
      >
        <FaExclamationTriangle className="mr-2 text-xl" />
        <span>
          You do not have permission (<strong>{permission}</strong>) to view
          this content.
        </span>
      </div>
    );
  }

  return <>{children}</>;
}

PermissionGuard.propTypes = {
  /** The exact permission key this component requires, e.g. "Home Page" */
  permission: PropTypes.string.isRequired,
  /** The protected UI to render if the user has access */
  children: PropTypes.node.isRequired,
};
